export default __webpack_public_path__ + "static/B0194-4bc11d8a93b7e0dc712c4353f260d4a3.png";